import styled from "styled-components";

export const FooterWrapper = styled.footer`
  background-color: black;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  /* position: fixed;
  bottom: 0; */
  width: 100vw;
  padding: 3rem 0;

  & > img {
    /* margin: 0 2rem 1rem 1rem; */
  }

  & > span {
    font-size: 1.4rem;
    /* color: #394255; */
    color: white;
  }

  & > h2 {
    margin: 0.5rem 0 5rem 0;
    font-size: 1.4rem;
  }

  & > a,
  p,
  h2 {
    /* color: #485574; */
    color: white;
    margin-left: 1rem;
    font-size: 1rem;
  }
`;
